var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 3.16634C1.33301 2.42996 1.92996 1.83301 2.66634 1.83301L9.33301 1.83301C10.0694 1.83301 10.6663 2.42996 10.6663 3.16634V5.83301H13.333C14.0694 5.83301 14.6663 6.42996 14.6663 7.16634L14.6663 13.833C14.6663 14.5694 14.0694 15.1663 13.333 15.1663L6.66634 15.1663C5.92996 15.1663 5.33301 14.5694 5.33301 13.833V11.1663H2.66634C1.92996 11.1663 1.33301 10.5694 1.33301 9.83301L1.33301 3.16634ZM6.66634 11.1663V13.833L13.333 13.833L13.333 7.16634H10.6663V9.83301C10.6663 10.5694 10.0694 11.1663 9.33301 11.1663H6.66634ZM9.33301 9.83301V3.16634L2.66634 3.16634L2.66634 9.83301H9.33301Z",
    fill: "#7F7F84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLogo);
export default __webpack_public_path__ + "static/media/copy-logo.daa5206a187b62966597a617b80c2aac.svg";
export { ForwardRef as ReactComponent };